import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('login');
  protected readonly currentYear = new Date().getFullYear();

  protected togglePassword(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement | null;
    if (!input) return;
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  protected toggleTheme(): void {
    const root = document.documentElement;
    const current = root.getAttribute('data-bs-theme') || 'light';
    root.setAttribute('data-bs-theme', current === 'light' ? 'dark' : 'light');
  }
}
